module.exports = __webpack_public_path__ + "static/media/drop.6e0194e0.svg";